export type VolumePage = {
  src: string
  label: string
  caption: string
  alt: string
}

/** Real interior pages from Volume 4, "The Game Bank", in display order. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/e7jmZSxvsk5nCQQdSPbLd9/01_vol4_p7.jpg',
    label: 'The practice plan',
    caption: 'Diagram, 60-min timeline and U8–U10 / U12–U14 versions on one page.',
    alt: '2v1 Pods on Parallel Goals practice plan from The Game Bank',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aESs7eYJHH63EfUJAP1mdQ/02_vol4_p8.jpg',
    label: 'Drills, cues & fixes',
    caption: 'The second page of every practice: what to say, and what to fix when it goes wrong.',
    alt: 'Drills, cues and fixes page for the 2v1 Pods practice',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9QQxd6AbzCXkKE7FWpSffJ/03_vol4_p38.jpg',
    label: 'Mini-field festival',
    caption: '3v3 on small fields: more touches, more goals, nobody in line.',
    alt: 'Mini-Field 3v3 Festival page with kids playing on three small fields',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3ZsVSgx3izKZhtRxPcFmZ4/04_vol4_p43.jpg',
    label: '20+ kids, 1 coach',
    caption: 'Field layouts and whistle signals to run big groups on your own.',
    alt: '20+ Kids, 1 Coach page with a multi-field setup for big groups',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/exkSAkwuiFFMNT6CrREhpm/05_vol4_p44.jpg',
    label: 'One drill, three levels',
    caption: 'Starter, Builder and Competitor versions of the same game.',
    alt: 'One Drill, Three Levels page showing starter, builder and competitor versions',
  },
]
